import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Testimonials.css';

const testimonials = [
  {
    name: "Priya Singh",
    role: "Local Guide",
    feedback: "Rishabh has great editing skills and helps beyond his limits to get the best results. Happy to share professional terms with him.",
    image: "https://i.pravatar.cc/100?img=5"
  },
  {
    name: "Dare Mevil",
    role: "Reviewer",
    feedback: "R.D'S Creations is giving the word 'Relationship' a new height! It connects people together and fills their lives with enthusiastic energy and positivity.",
    image: "https://i.pravatar.cc/100?img=12"
  },
  {
    name: "Abhishek Mishra",
    role: "Local Guide",
    feedback: "Rishabh has a good set of editing skills, and I have never been disappointed with his work. I always suggest him for video editing.",
    image: "https://i.pravatar.cc/100?img=47"
  }
];

const Testimonials = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <section id="testimonials" className="testimonials-section" data-aos="fade-up">
      <h2 data-aos="zoom-in" data-aos-delay="100">What Our Clients Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((t, index) => (
          <div
            className="testimonial-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 200}
          >
            <h3>{t.name}</h3>
            <p className="testimonial-role">{t.role}</p>
            <p className="testimonial-text">“{t.feedback}”</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;